import { data } from '../../svg/TwoColumns/data';
import { makeIcon } from '../makeIcon';

export const TwoColumns = makeIcon(data, 'two_columns', 'TwoColumns');

export default TwoColumns;
